'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var conditionEnumToText = function conditionEnumToText(condition, newSubtr) {
  return condition && condition.replace(/_/g, newSubtr || ' ');
};

exports.default = conditionEnumToText;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/conditionEnumToText.js
// module id = 357
// module chunks = 0